const carouselItems = [
  {
    title: '动作大片',
    desc: '肾上腺素飙升的视觉盛宴，枪战、格斗、追逐一应俱全',
    img: 'https://readdy.ai/api/search-image?query=Explosive%20action%20movie%20scene%20collage%20with%20dynamic%20car%20chase%20and%20intense%20fight%20scene%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20no%20text%2C%20dramatic%20composition%2C%20modern%20film%20poster%20style%2C%20dark%20background%20with%20vivid%20highlights&width=600&height=350&seq=carousel-action&orientation=landscape',
  },
  {
    title: '悬疑推理',
    desc: '层层反转烧脑剧情，每一帧都暗藏玄机',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20noir%20scene%20with%20shadowy%20figure%20in%20rainy%20alley%2C%20cool%20blue%20and%20warm%20yellow%20contrast%20lighting%2C%20film%20noir%20aesthetic%2C%20no%20text%2C%20atmospheric%20fog%20and%20silhouettes%2C%20cinematic%20composition%2C%20vintage%20detective%20vibe&width=600&height=350&seq=carousel-mystery&orientation=landscape',
  },
  {
    title: '喜剧搞笑',
    desc: '轻松解压欢乐不断，全家老少齐开怀',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20comedy%20movie%20collage%20with%20colorful%20fun%20elements%2C%20warm%20yellow%20and%20pink%20tones%2C%20playful%20confetti%20and%20laughter%2C%20no%20text%2C%20lighthearted%20cinematic%20style%2C%20clean%20and%20happy%20composition%2C%20modern%20illustration&width=600&height=350&seq=carousel-comedy&orientation=landscape',
  },
  {
    title: '科幻奇幻',
    desc: '遨游未来世界与魔法大陆，想象力无边界',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20cityscape%20with%20neon%20lights%20and%20floating%20structures%2C%20purple%20and%20cyan%20tones%2C%20no%20text%2C%20digital%20art%20style%2C%20atmospheric%20cyberpunk%20aesthetic%2C%20glowing%20holograms%2C%20cinematic%20wide%20angle&width=600&height=350&seq=carousel-scifi&orientation=landscape',
  },
  {
    title: '动漫番剧',
    desc: '热血与治愈交织，二次元世界的无限精彩',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20illustration%20with%20vibrant%20cherry%20blossom%20and%20starlit%20sky%2C%20soft%20pink%20and%20blue%20gradient%2C%20no%20text%2C%20dreamy%20and%20colorful%20composition%2C%20Japanese%20animation%20aesthetic%2C%20clean%20illustration%20style&width=600&height=350&seq=carousel-anime&orientation=landscape',
  },
  {
    title: '经典重温',
    desc: '影史不朽名作，每一部都值得再看一遍',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20projector%20with%20golden%20film%20reel%20and%20warm%20sepia%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20no%20text%2C%20old%20Hollywood%20glamour%20style%2C%20soft%20warm%20lighting%2C%20elegant%20composition&width=600&height=350&seq=carousel-classic&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            精彩专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选六大观影专题，总有一个主题让你停不下来
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.title} - 6080影院高清电影免费看专题`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-100 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}